<template lang="pug">
transition(
    name="fade"
    mode="out-in"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
)
    slot
</template>

<script lang="ts">
import Vue from 'vue'

import { useAutoHeight } from './useAutoHeight'

export default Vue.extend({
    name: 'AnimatedHeightTransition',
    setup() {
        const { enter, afterEnter, leave } = useAutoHeight()

        return { enter, afterEnter, leave }
    },
})
</script>

<style module lang="scss"></style>
